import { Component, Prop, Vue } from 'vue-property-decorator';
import { IDeliveryAddressViewModel} from "Components/Ecom/Checkout/Shipping/DeliveryAddress";
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';

interface IPaymentMethod{
    id: string;
    value: string;
    type: string;
    partialDeliveryIsAllowed: boolean;
    selected: boolean;
}


@Component({
})
export default class BasicCheckoutComponent extends mixins(BaseComponent) {

    //v-model this
    public selectedPaymentMethodValue: string = null; 
    private paymentMethods: IPaymentMethod[] = this.loadPaymentMethods('EcomCartPaymethodID');

   

    async created(){

        //initialize selected payment method
        this.selectedPaymentMethodValue = this.paymentMethods.find(x => x.selected)?.value;
    }

    //returns a map of payment methods in a known data type
    private loadPaymentMethods(inputName: string): IPaymentMethod[]{
        const result = Array.from(document.querySelectorAll(`input[name="${inputName}"]`));
        
        return result.map((value: HTMLInputElement, key: number) => {
            console.log("Result:", value.dataset);
            return <IPaymentMethod>{
                type: value.dataset.paymentType,
                id: value.id,
                value: value.dataset.value,
                partialDeliveryIsAllowed: Boolean(JSON.parse(value.dataset.paymentPartialDeliveryIsAllowed)),
                selected: value.checked
            }
        });
    }

    get isPartialDeliveryAllowed(): boolean {
        return this.paymentMethods.find(x => x.value == this.selectedPaymentMethodValue)?.partialDeliveryIsAllowed;
    }
    

}
Vue.component('basic-checkout', BasicCheckoutComponent);